export interface BomError {
   message: string;
   retryable: boolean;
}

export const createBomError = (error: unknown): BomError => {
   if (!error) return { message: 'An unknown error occurred', retryable: true };

   if (typeof error === 'object') {
      const errorObj = error as any;
      const message = errorObj.response?.data?.message || errorObj.message || 'An error occurred';
      return { message, retryable: true };
   }

   return { message: String(error), retryable: true };
};

export const sortBomVersions = (versions: string[]): string[] => {
   return [...versions].sort((a, b) => {
      const [yearA, monthA] = a.split('-');
      const [yearB, monthB] = b.split('-');

      if (yearB === yearA) {
         return parseInt(monthB) - parseInt(monthA);
      }
      return parseInt(yearB) - parseInt(yearA);
   });
};
